import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Tippy from '~components/tippy';
import { PAYMENT_ITEM_STATUS } from '~graphql-types';
import {
  TickSmallAwaiting,
  TickSmallCorrect,
  TickSmallDeposited,
  TickSmallError,
  TickSmallInvoiced,
  TickSmallMoved,
  TickSmallPending,
  TickSmallRefunded,
  TickSmallReturned,
  TickSmallVoid,
  TickSmallWaived,
} from '~svg-components';

const PaymentItemStatusIcon = React.forwardRef((props, ref) => {
  const { t } = useTranslation('graphql');
  const { status, ...otherProps } = props;

  let Icon;
  switch (status) {
    case PAYMENT_ITEM_STATUS.OVERDUE: {
      Icon = TickSmallError;
      break;
    }
    case PAYMENT_ITEM_STATUS.PAID: {
      Icon = TickSmallCorrect;
      break;
    }
    case PAYMENT_ITEM_STATUS.INVOICED:
    case PAYMENT_ITEM_STATUS.REMAINING: {
      Icon = TickSmallInvoiced;
      break;
    }
    case PAYMENT_ITEM_STATUS.VOID: {
      Icon = TickSmallVoid;
      break;
    }
    case PAYMENT_ITEM_STATUS.REFUNDED: {
      Icon = TickSmallRefunded;
      break;
    }
    case PAYMENT_ITEM_STATUS.DEPOSITED: {
      Icon = TickSmallDeposited;
      break;
    }
    case PAYMENT_ITEM_STATUS.PENDING: {
      Icon = TickSmallPending;
      break;
    }
    case PAYMENT_ITEM_STATUS.RETURNED: {
      Icon = TickSmallReturned;
      break;
    }
    case PAYMENT_ITEM_STATUS.TRANSFERRED: {
      Icon = TickSmallMoved;
      break;
    }
    case PAYMENT_ITEM_STATUS.WAIVED: {
      Icon = TickSmallWaived;
      break;
    }
    case PAYMENT_ITEM_STATUS.AWAITING: {
      Icon = TickSmallAwaiting;
      break;
    }
    default: {
      break;
    }
  }

  return (
    Icon && (
      <Tippy content={t(`payment_item_status.${status}`)} ref={ref} theme="tooltip" {...otherProps}>
        <Icon />
      </Tippy>
    )
  );
});

PaymentItemStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
};

export default PaymentItemStatusIcon;
